import axios from 'axios'
import utils from './utils'

let paymentInputFilter = {
  id: {
      name: 'id',
      value: '',
      type: 'number',
      placeholder: 'transaction ID'
  },
  accounts: {
      name: 'accounts',
      type: 'select',
      value: '',
      selected: null,
      items: []
  },
  product: {
      name: 'products',
      type: 'select',
      value: '',
      selected: null,
      items: []
  },
  paymentTypes: {
      name: 'paymentTypes',
      type: 'select',
      value: '',
      selected: null,
      items: [
        {label: 'LINK', id: 1, data: {type: 'LINK'}},
        {label: 'POS', id: 2, data: {type: 'POS'}},
        {label: 'REFUND_IBAN', id: 3, data: {type: 'REFUND_IBAN'}}
      ]
  },
  amountFrom:{
      name: 'amountFrom',
      type: 'number',
      value: '',
      placeholder: 'from ...'
  },
  amountTo:{
      name: 'amountTo',
      type: 'number',
      value: '',
      placeholder: 'to...'
  },
  currency: {
      name: 'currencies',
      value: '',
      type: 'select',
      selected: null,
      items: []
  },
  status: {
      name: 'transactionStatuses',
      value: '',
      type: 'select',
      selected: null,
      items: []
  },
  maskedPan: {
      name: 'maskedPan',
      value: '',
      type: 'text',
      placeholder: 'masked pan'
  },
  paymentReference:{
      name: 'paymentReference',
      value: '',
      type: 'text',
      placeholder: 'payment reference'
  },
  rrn: {
      name: 'rrn',
      value: '',
      type: 'text',
      placeholder: 'rrn'
  },
  traceId: {
      name: 'traceId',
      value: '',
      type: 'text',
      placeholder: 'trace ID'
  },
  reference: {
      name: 'reference',
      value: '',
      type: 'text',
      placeholder: 'reference'
  },
  primaryContact: {
      name: 'primaryContact',
      value: '',
      type: 'text',
      placeholder: 'name'
  },
  email: {
      name: 'email',
      value: '',
      type: 'text',
      placeholder: 'Email'
  },
  mobile: {
      name: 'mobile',
      value: '',
      type: 'text',
      placeholder: 'mobile'
  },
  validityTo: {
    name: 'validityTo',
    value: null,
    type: 'text',
    isDate: true
  },
  validityFrom: {
    name: 'validityFrom',
    value: null,
    type: 'text',
    isDate: true
  },
  createdDateFrom: {
    name: 'createdDateFrom',
    value: null,
    type: 'text',
    isDate: true
  },
  createdDateTo: {
    name: 'createdDateTo',
    value: null,
    type: 'text',
    isDate: true
  },
  createdUser: {
    name: 'createdUsers',
    value: '',
    type: 'select',
    selected: null
  },
  createdOffice: {
    name: 'createdOffices',
    value: '',
    type: 'select',
    selected: null
  },
  approvedUsers: {
    name: 'approvedUsers',
    value: '',
    type: 'select',
    selected: null
  },
  txnDateFrom: {
    name: 'txnDateFrom',
    value: null,
    type: 'text',
    isDate: true
  },
  txnDateTo: {
    name: 'txnDateTo',
    value: null,
    type: 'text',
    isDate: true
  },
  autoAmount: {
    name: 'autoAmount',
    value: '',
    type: 'text'
  },
  autoBooking: {
    name: 'autoBooking',
    value: '',
    type: 'text'
  },
  purchaseId: {
    name: 'purchaseId',
    value: '',
    type: 'text'
  },
  page:0,
  rowsPerPage:10,
  totalCounts:-1,
  sortField: '',
  direction: ''
}


const defaultInputs = {
    id: {
        name: 'id',
        value: '',
        type: 'number',
        placeholder: 'transaction ID'
    },
    accounts: {
        name: 'accounts',
        type: 'select',
        value: '',
        selected: null,
        items: []
    },
    product: {
        name: 'products',
        type: 'select',
        value: '',
        selected: null,
        items: []
    },
    paymentTypes: {
      name: 'paymentTypes',
      type: 'select',
      value: '',
      selected: null,
      items: [
        {label: 'LINK', id: 1, data: {type: 'LINK'}},
        {label: 'POS', id: 2, data: {type: 'POS'}},
        {label: 'REFUND_IBAN', id: 3, data: {type: 'REFUND_IBAN'}}
      ]
    },
    amountFrom:{
        name: 'amountFrom',
        type: 'number',
        value: '',
        placeholder: 'from ...'
    },
    amountTo:{
        name: 'amountTo',
        type: 'number',
        value: '',
        placeholder: 'to...'
    },
    currency: {
        name: 'currencies',
        value: '',
        type: 'select',
        selected: null,
        items: []
    },
    status: {
        name: 'transactionStatuses',
        value: '',
        type: 'select',
        selected: null,
        items: []
    },
    maskedPan: {
        name: 'maskedPan',
        value: '',
        type: 'text',
        placeholder: 'masked pan'
    },
    paymentReference:{
        name: 'paymentReference',
        value: '',
        type: 'text',
        placeholder: 'payment reference'
    },
    rrn: {
        name: 'rrn',
        value: '',
        type: 'text',
        placeholder: 'rrn'
    },
    traceId: {
        name: 'trace ID',
        value: '',
        type: 'text',
        placeholder: 'trace ID'
    },
    reference: {
        name: 'reference',
        value: '',
        type: 'text',
        placeholder: 'reference'
    },
    primaryContact: {
        name: 'primaryContact',
        value: '',
        type: 'text',
        placeholder: 'name'
    },
    email: {
        name: 'email',
        value: '',
        type: 'text',
        placeholder: 'Email'
    },
    mobile: {
        name: 'mobile',
        value: '',
        type: 'text',
        placeholder: 'mobile'
    },
    validityTo: {
      name: 'validityTo',
      value: null,
      type: 'text',
      isDate: true
    },
    validityFrom: {
      name: 'validityFrom',
      value: null,
      type: 'text',
      isDate: true
    },
    createdDateTo: {
      name: 'createdDateTo',
      value: null,
      type: 'text',
      isDate: true
    },
    createdDateFrom: {
      name: 'createdDateFrom',
      value: null,
      type: 'text',
      isDate: true
    },
    createdUser: {
        name: 'createdUsers',
        value: '',
        type: 'select',
        selected: null
    },
    createdOffice: {
        name: 'createdOffices',
        value: '',
        type: 'select',
        selected: null
    },
    approvedUsers: {
      name: 'approvedUsers',
      value: '',
      type: 'select',
      selected: null
    },
    txnDateFrom: {
        name: 'txnDateFrom',
        value: null,
        type: 'text',
        isDate: true
    },
    txnDateTo: {
        name: 'txnDateTo',
        value: null,
        type: 'text',
        isDate: true
    },
    autoAmount: {
      name: 'autoAmount',
      value: '',
      type: 'text'
    },
    autoBooking: {
      name: 'autoBooking',
      value: '',
      type: 'text'
    },
    purchaseId: {
      name: 'purchaseId',
      value: '',
      type: 'text'
    },
    page:0,
    rowsPerPage:10,
    totalCounts:-1,
    sortField: '',
    direction: ''
  
}


const clearInputFields = () => {
    setPaymentInputFilter(defaultInputs)
}

const paymentInputFilterListeners = []
const setPaymentInputFilter = (input)=>{
  paymentInputFilter = {...input}
  for(let i=0; i< paymentInputFilterListeners.length; i++){
    paymentInputFilterListeners[i](paymentInputFilter)
  }
}
const getPaymentInputFilter = ()=>{
  return paymentInputFilter
}

const addListenerPaymentInputFilter = (fn) =>{
  paymentInputFilterListeners.push(fn) 
}



//======================= office inputFields ===================



let officeInputFilter = {
    name: {
      name: "name",
      value: "",
      type: "text",
      placeholder: "office name",
    },
    code: {
      name: "code",
      value: "",
      type: "text",
      placeholder: "Office Code ...",
    },
    email: {
      name: "email",
      value: "",
      type: "text",
      placeholder: "agency@example.com",
    },
    phone: {
      name: "phone",
      value: "",
      type: "text",
      placeholder: "(+237) 696 88 77 55",
    },
    accounting: {
      name: "accounting",
      value: "",
      type: "number",
      placeholder: "10001",
    },
    iata: {
      name: "iata",
      value: "",
      type: "text",
      placeholder: "THR",
    },
    contactPerson: {
      name: "contactPerson",
      value: "",
      type: "text",
      placeholder: "Manager name ...",
    },
    mobile: {
      name: "mobile",
      value: "",
      type: "text",
      placeholder: "0912 *** ** **",
    },
    city: {
      name: "city",
      value: "",
      type: "select",
      selected: null,
      items: [],
      icon: <i className="icon-Star-1"></i>,
    },
    address: {
      name: "address",
      value: "",
      type: "text",
      placeholder: "Street, Avenue, Alley, Plaque",
    },
    currency: {
      name: "currency",
      value: "",
      type: "select",
      items: [],
      selected: null
    },
    economicCode: {
      name: "economicCode",
      value: "",
      type: "text",
      placeholder: 'economic code'
    },
    page: 0,
    totalCounts: -1,
    rowsPerPage:10
}


const officeDefaultValue = {
    name: {
      name: "name",
      value: "",
      type: "text",
      placeholder: "office name",
    },
    code: {
      name: "code",
      value: "",
      type: "text",
      placeholder: "Office Code ...",
    },
    email: {
      name: "email",
      value: "",
      type: "text",
      placeholder: "agency@example.com",
    },
    phone: {
      name: "phone",
      value: "",
      type: "text",
      placeholder: "(+237) 696 88 77 55",
    },
    accounting: {
      name: "accounting",
      value: "",
      type: "number",
      placeholder: "10001",
    },
    iata: {
      name: "iata",
      value: "",
      type: "text",
      placeholder: "THR",
    },
    contactPerson: {
      name: "contactPerson",
      value: "",
      type: "text",
      placeholder: "Manager name ...",
    },
    mobile: {
      name: "mobile",
      value: "",
      type: "text",
      placeholder: "0912 *** ** **",
    },
    city: {
      name: "city",
      value: "",
      type: "select",
      selected: null,
      items: [],
      icon: <i className="icon-Star-1"></i>,
    },
    address: {
      name: "address",
      value: "",
      type: "text",
      placeholder: "Street, Avenue, Alley, Plaque",
    },
    currency: {
      name: "currency",
      value: "",
      type: "select",
      items: [],
      selected: null
    },
    economicCode: {
      name: "economicCode",
      value: "",
      type: "text",
      placeholder: 'economic code'
    },
    page: 0,
    totalCounts: -1,
    rowsPerPage:10
}

const officeInputFilterListeners = []

const clearOfficeInputfilter = () => {
    setOfficeInputFilter(officeDefaultValue)
}


const setOfficeInputFilter = (input)=>{
    officeInputFilter = {...input}
    for(let i=0; i< officeInputFilterListeners.length; i++){
        officeInputFilterListeners[i](officeInputFilter)
    }
}

const getOfficeInputFilter = () => {
    return officeInputFilter
}


const addListenerOfficeInputFilter = (fn) =>{
    officeInputFilterListeners.push(fn) 
  }



//=======================user inputFields==============


let userInputFields = {
  username: {
    name: 'username',
    value: '',
    type: 'text',
    placeholder: 'username'
},
name: {
    name: 'name',
    type: 'text',
    value: '',
    placeholder: 'name'
},
mobile: {
    name: 'mobile',
    type: 'text',
    value: '',
    placeholder: 'mobile'
},
email: {
    name: 'email',
    type: 'text',
    value: '',
    placeholder: 'email'
},
status: {
    name: 'status',
    type: 'select',
    value: null,
    selected: null,
    items: []
},
roles: {
    name: 'roles',
    type: 'select',
    value: '',
    selected: null,
    items: []
},
offices: {
    name: 'offices',
    type: 'select',
    value: null,
    selected:null,
    items:[]
},
page: 0,
totalCounts: -1,
rowsPerPage:10,
}


const defaultUserInputFields = {...userInputFields}

const userInputFilterListeners = []

const clearUserInputfilter = () => {
  setUserInputFilter(defaultUserInputFields)
}

const setUserInputFilter = (input)=>{
  userInputFields = {...input}
  for(let i=0; i< userInputFilterListeners.length; i++){
      userInputFilterListeners[i](userInputFields)
  }
}

const getUserInputFilter = () => {
  return userInputFields
}


const addListenerUserInputFilter = (fn) =>{
  userInputFilterListeners.push(fn) 
}





//======================= Roles inputFields ===============

let roleInputFilter = {
  status: {
    name: 'status',
    type: 'select',
    value: '',
    selected: null,
    items: []
  },
  privileges: {
    name: 'privileges',
    type: 'select',
    value: [],
    selected: null,
    items: []
  },
  name: {
    name: 'name',
    type: 'text',
    value: '',
    placeholder: 'Role name ...'
  },
  page: 0,
  totalCounts: -1,
  rowsPerPage:10
}

const roleDefaultInputFilter = {...roleInputFilter}

const roleInputFilterListeners = []

const clearRoleInputfilter = () => {
  setRoleInputFilter(roleDefaultInputFilter)
}

const setRoleInputFilter = (input)=>{
  roleInputFilter = {...input}
  for(let i=0; i< roleInputFilterListeners.length; i++){
      roleInputFilterListeners[i](roleInputFilter)
  }
}
const getRoleInputFilter = () => {
  return roleInputFilter
}

const addListenerRoleInputFilter = (fn) =>{
  roleInputFilterListeners.push(fn) 
}





//======================= isLoggedIn ===========================
const base64UrlRegex = /^[A-Za-z0-9_-]+$/

const decodeBase64Url = (str) => {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/')
  return window.atob(base64.padEnd(base64.length + (4 - base64.length % 4) % 4, '='))
}

// checks all 3 parts of the token (except expiration) and returns the decoded payload, or null if invalid
const decodeToken = (token) => {
  if(!token) return null
  try {
    const parts = token.split('.')
    if(parts.length !== 3) return null
    const [headerPart, payloadPart, signaturePart] = parts
    if(!parts.every(p => base64UrlRegex.test(p))) return null

    // header
    const header = JSON.parse(decodeBase64Url(headerPart))
    if(!header || typeof header !== 'object') return null
    if(!header.alg || header.alg.toLowerCase() === 'none') return null
    if(header.typ && header.typ.toUpperCase() !== 'JWT') return null

    // payload
    const payload = JSON.parse(decodeBase64Url(payloadPart))
    if(!payload || typeof payload !== 'object') return null
    if(typeof payload.exp !== 'number') return null
    if(typeof payload.nbf === 'number' && payload.nbf > Date.now() / 1000) return null

    // signature
    if(decodeBase64Url(signaturePart).length === 0) return null

    return payload
  } catch (e) {
    console.log(e)
    return null
  }
}

// token expiration in milliseconds, or null if the token is invalid
const getTokenExpiration = () => {
  const payload = decodeToken(window.localStorage.getItem('token'))
  return payload ? payload.exp * 1000 : null
}

let refreshPromise = null

// shared by all callers so parallel requests don't refresh the token more than once
const refreshToken = () => {
  if(refreshPromise) return refreshPromise

  refreshPromise = axios({ url: utils.urls.refreshToken, method: 'POST' , data: {refreshToken: window.localStorage.getItem('refreshToken')}})
    .then(res => {
      window.localStorage.setItem('token', res.data.token)
      window.localStorage.setItem('refreshToken', res.data.refreshToken)
      return true
    })
    .catch(e => {
      console.log(e)
      setIsLoggedIn(false)
      window.localStorage.clear()
      return false
    })
    .finally(() => {
      refreshPromise = null
    })

  return refreshPromise
}

const tokenPayload = decodeToken(window.localStorage.getItem('token'))
let isLoggedIn = !!tokenPayload
if (!isLoggedIn) window.localStorage.clear()

//======================= userInfo ===========================
let userInfo = null
let userInfoListeners = []

const setUserInfo = (info) => {
  userInfo = info
  for(let i=0; i< userInfoListeners.length; i++){
    userInfoListeners[i](userInfo)
  }
}
const getUserInfo = () => {
  return userInfo
}
const addListenerUserInfo = (fn) => {
  userInfoListeners.push(fn)
}
const removeListenerUserInfo = (fn) => {
  userInfoListeners = userInfoListeners.filter(l => l !== fn)
}

const fetchUserInfo = async () => {
  const res = await axios({
    method: 'GET',
    url: utils.urls.userInformation,
    headers: { Authorization: `Bearer ${window.localStorage.getItem('token')}` }
  }).catch(e => {
    console.log(e)
    setIsLoggedIn(false)
  })

  if(!res) return
  setUserInfo(res.data)
}

const initSession = async () => {
  if(tokenPayload.exp * 1000 < Date.now()) {
    const refreshed = await refreshToken()
    if(!refreshed) return
  }
  fetchUserInfo()
}

if (isLoggedIn) initSession()

let isLoggedInListeners = []

const setIsLoggedIn = (il) => {
    isLoggedIn = il
    for(let i=0; i< isLoggedInListeners.length; i++){
        isLoggedInListeners[i](isLoggedIn)
      }
    if(!isLoggedIn) {
      window.localStorage.clear()
      setUserInfo(null)
    }
}
const getIsLoggedIn = (il) => {
   return isLoggedIn
}
const addListenerIsLoggedIn = (il) => {
    isLoggedInListeners.push(il)
}

const ex = {
  setPaymentInputFilter,
  getPaymentInputFilter,
  addListenerPaymentInputFilter,
  setIsLoggedIn,
  getIsLoggedIn,
  addListenerIsLoggedIn,
  setUserInfo,
  getUserInfo,
  addListenerUserInfo,
  removeListenerUserInfo,
  fetchUserInfo,
  getTokenExpiration,
  refreshToken,
  clearInputFields,
  setOfficeInputFilter,
  getOfficeInputFilter,
  addListenerOfficeInputFilter,
  clearOfficeInputfilter,
  clearUserInputfilter,
  setUserInputFilter,
  getUserInputFilter,
  addListenerUserInputFilter,
  clearRoleInputfilter,
  setRoleInputFilter,
  getRoleInputFilter,
  addListenerRoleInputFilter
}

export default ex 